import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-right-arrow',
    templateUrl: '../svgs/ArrowIcon.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--right-arrow'
    },
    standalone: false
})
export class TellerOnlineIconRightArrow {
}
